function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  y1: 1,
  x2: 12,
  y2: 1,
  stroke: "#A8A8A8",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  y1: 5,
  x2: 12,
  y2: 5,
  stroke: "#A8A8A8",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  y1: 9,
  x2: 12,
  y2: 9,
  stroke: "#A8A8A8",
  strokeWidth: 2
});

var SvgMenuBtn = function SvgMenuBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-btn.97a542d1.svg";
export { ForwardRef as ReactComponent };